import type { Domain } from '@/config/domain/type';

export const trademarksOnlineBenelux: Domain = {
    domain: import.meta.env.VITE_TMO_BX_DOMAIN,
    website: 'https://www.trademarksonline.be',
    shortCode: 'TMO-BX',
    markSource: '',
    title: 'Apply for your Benelux trademark',
    name: 'Trademarks Online Benelux',
    description: 'Our online trademark registration platform is available 24/7 and takes just minutes. Apply for your Benelux trademark by entering your trademark or logo.',
    logo: '/img/TM-Logo-White-Thin.png',
    menuItems: [
        { label: 'Home', url: '' },
        { label: 'Pricing', url: '/pricing' },
        { label: 'FAQ', url: '/trademark-questions' },
        { label: 'About', url: '/about-us' },
    ],
    footerItems: [
        { label: 'Privacy Policy', url: '/privacy-policy' },
        { label: 'Terms of Use', url: '/terms-of-use' },
        { label: 'Contact Us', url: '/contact' },
    ],
    termOfUseUrl: '/terms-of-use',
    bannerImageUrl: '',
    gtmId: 'GTM-N6LJGWQ5',
};
